import type { NewsResponseBasicInfoAllOf } from './newsResponseBasicInfoAllOf';
import type { NewsResponseBasicInfoAllOfTwo } from './newsResponseBasicInfoAllOfTwo';

export type NewsResponseBasicInfo = NewsResponseBasicInfoAllOf & NewsResponseBasicInfoAllOfTwo;
